"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageConfig = void 0;
const config_1 = require("../config");
class LanguageConfig {
    constructor(selected) {
        this.translationDataKey = "data-i18n-key";
        this.translationDataAttr = "data-i18n-attr";
        const supported = new Array();
        config_1.config.language.supported.forEach((lang) => supported.push(lang[0].toString()));
        const options = {};
        config_1.config.language.supported.forEach((lang) => options[lang[0]] = lang[1]);
        this.supported = supported; // ['en', 'sl'];
        this.options = options; // { 'en' : 'ENGLISH', 'sl': 'SLOVENIAN' }
        this.selected = selected !== null && selected !== void 0 ? selected : config_1.config.language.default; // get from host app
        this.default = config_1.config.language.default; // 'en'
        this.resources = config_1.config.language.resources; // { en: { translation: en }, sl: { translation: sl } }
    }
}
exports.LanguageConfig = LanguageConfig;
